/**
 * WHAT: MySQL password policy compliance wrapper component.
 * WHY: Provides a dedicated route entry point for MySQL compliance, delegating to the
 *      generic PasswordPolicyCompliance with the technology pre-configured.
 */

import React from 'react';
import PasswordPolicyCompliance from './PasswordPolicyCompliance';

/**
 * WHAT: Thin wrapper that renders PasswordPolicyCompliance pre-configured for MySQL.
 * WHY: Each database technology has its own route/menu entry; this wrapper lets the router
 *      mount a technology-specific component without leaking the technology prop into routing config.
 */
const MysqlPasswordCompliance = () => {
  return <PasswordPolicyCompliance technology="mysql" />;
};

export default MysqlPasswordCompliance;
